import { createContext } from 'react';

import { Event } from '@gp/models';

const defaultValue: Event = new Event({});
export const EventContext = createContext<Event>(defaultValue);